import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FuseCardComponent } from '@fuse/components/card';
import { TFMService } from 'app/mock-api/tfm.service';
import { HeadingSectionType01Component } from '../../heading-section/heading_section-type01/heading_section-type01.component';
import { NgClass, NgStyle } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { TeamModalComponent } from '../modals/teams-modal/team.component';

@Component({
  selector: 'app-about-type01',
  standalone: true,
  imports: [MatIconModule,FuseCardComponent,HeadingSectionType01Component, NgStyle, NgClass, RouterLink,MatTooltipModule],
  templateUrl: './about-type01.component.html',
  styleUrl: './about-type01.component.scss'
})
export class AboutType01Component implements OnInit {

  public view: any = {
    title: '',
    isModalOpen: false,
    selectedMember: null,
    teamMembers: [
      {
        id: 1,
        name: "Sechaba Montsitsi",
        email: "sechaba@simplynexus.co.za",
        phone: "010 109 2198",
        phoneAfterHours: "064 339 4455",
        company: "Travel Simplifier",
        image: "/assets/images/avatars/Sechaba Montsitsi.png"
      },
      {
        id: 2,
        name: "Zusiphe Jekwa",
        email: "zusiphe@simplynexus.co.za",
        phone: "010 109 2198",
        phoneAfterHours: "064 339 4455",
        company: "Travel Simplifier",
        image: "/assets/images/avatars/Zusiphe Jekwa.png"
      },
      {
        id: 3,
        name: "Vina Daya",
        email: "vina@simplynexus.co.za",
        phone: "010 109 2198",
        phoneAfterHours: "064 339 4455",
        company: "Travel Simplifier",
        image: "/assets/images/avatars/Vina Daya.png"
      },
      {
        id: 4,
        name: "Vandana Naran",
        email: "vandana@simplynexus.co.za",
        phone: "010 109 2198",
        phoneAfterHours: "064 339 4455",
        company: "Travel Simplifier",
        image: "/assets/images/avatars/Vandana Naran.png"
      },
      {
        id: 4,
        name: "Rene Swart",
        email: "rene@simplynexus.co.za",
        phone: "010 109 2198",
        phoneAfterHours: "064 339 4455",
        company: "Lead Travel Simplifier",
        image: "/assets/images/avatars/Rene Swart.png"
      },
    ]
  }

  openModal(member: any) {
    this.dialog.open(TeamModalComponent, {
      width: '400px',
      data: member
    });
  }


  constructor(public _tfmService: TFMService,private _cd: ChangeDetectorRef,public dialog: MatDialog) {
    
    this._tfmService.getContentBySection('about').then(res => {
      this.view.page = res;
      this._tfmService.log(this.view);

      if (this.view.page && this.view.page?.content?.images && this.view.page?.content?.images.length > 0) {
        const image = this.view.page?.content?.images[0]; // Access the first image object
        const links = image._links; // Access the _links array
      
        // Find the link with rel "view"
        const viewLink = links.find((link: any) => link.rel === "view");
      
        // Get the href if the view link exists
        if (viewLink) {
          this.view.imageHref = viewLink.href;
          this._tfmService.log("Image href:", this.view.imageHref);
          this._cd.detectChanges();
        } else {
          console.error("View link not found");
        }
      } else {
        console.error("Images not available");
      }
    });
    
    this._tfmService.getSite().then(res => {
        this.view.site = res;

        this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
        this._tfmService.log(this.view);
      });
      
  }

  ngOnInit(): void {
  }
}

